<!-- Hero End -->
<section class="home-slider position-relative" id="home">
  <div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
      <owl-carousel-o id="customer-testi" [options]="customOptions">
        <ng-template carouselSlide>
          <div class="slide-inner d-flex align-items-center vh-100" style="background: center center;"
        style="background-image:url('assets/images/corporate/1.jpg')">
        <div class="bg-overlay"></div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="title-heading text-center">
                <h1 class="heading text-white title-dark mb-4">Découvrez l'avenir de la <br> transformation digitale</h1>
                <p class="para-desc mx-auto text-white-50">Accélérez votre croissance avec nos experts en solutions IT innovantes. De la conception d'applications sur mesure à l'automatisation intelligente de vos processus, nous transformons vos défis en opportunités digitales.</p>

                <div class="mt-4 pt-2">
                  <a href="javascript:void(0)" class="btn btn-primary">Démarrer maintenant</a> 
                </div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row--> 
        </div>
        <!--end container-->
      </div><!-- end slide-inner -->
          <!--end slide-->
        </ng-template>
        <ng-template carouselSlide>
          <div class="slide-inner d-flex align-items-center vh-100" style="background: center center;"
        style="background-image:url('assets/images/corporate/2.jpg')">
        <div class="bg-overlay"></div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="title-heading text-center">
                <h1 class="heading text-white title-dark mb-4">Rencontrez nos solutions <br> technologiques de pointe</h1>
                <p class="para-desc mx-auto text-white-50">Bénéficiez de notre expertise en Cloud DevOps, intelligence artificielle et développement web. Nous accompagnons votre entreprise dans sa révolution digitale avec des technologies de dernière génération.</p>

                <div class="mt-4 pt-2">
                  <a href="javascript:void(0)" class="btn btn-primary">Nous contacter</a>
                </div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
        <!--end container-->
      </div><!-- end slide-inner -->
          <!--end slide-->
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</section>

<section class="section bg-light">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <div class="features-absolute">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-12">
              <div
                class="card features feature-clean feature-primary explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                <div class="icons text-primary text-center mx-auto">
                  <i class="uil uil-airplay d-block rounded h3 mb-0"></i>
                </div>

                <div class="card-body p-0 content">
                  <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Conseil IT d'Excellence</a></h5>
                  <p class="text-muted">Notre équipe d'experts vous accompagne dans l'adoption des meilleures pratiques IT, de l'architecture Cloud à la sécurité des données, pour optimiser vos performances business.</p>

                  <a href="javascript:void(0)" class="text-primary">En savoir plus <i
                      class="uil uil-angle-right-b align-middle"></i></a>
                </div>
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6 col-12 mt-4 mt-md-0 pt-2 pt-md-0">
              <div
                class="card features feature-clean feature-primary explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                <div class="icons text-primary text-center mx-auto">
                  <i class="uil uil-clipboard-alt d-block rounded h3 mb-0"></i>
                </div>

                <div class="card-body p-0 content">
                  <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Solutions Cloud DevOps</a>
                  </h5>
                  <p class="text-muted">Automatisez vos déploiements, améliorez la fiabilité de vos applications et réduisez vos coûts d'exploitation avec nos services Cloud DevOps sur mesure.</p>

                  <a href="javascript:void(0)" class="text-primary">En savoir plus <i
                      class="uil uil-angle-right-b align-middle"></i></a>
                </div>
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6 col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
              <div
                class="card features feature-clean feature-primary explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                <div class="icons text-primary text-center mx-auto">
                  <i class="uil uil-credit-card-search d-block rounded h3 mb-0"></i>
                </div>

                <div class="card-body p-0 content">
                  <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Intelligence Artificielle</a></h5>
                  <p class="text-muted">Intégrez l'IA dans vos processus métier pour gagner en efficacité. De l'analyse prédictive aux chatbots intelligents, nous concrétisons vos projets d'automatisation.</p>

                  <a href="javascript:void(0)" class="text-primary">En savoir plus <i
                      class="uil uil-angle-right-b align-middle"></i></a>
                </div>
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6 col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
              <div
                class="card features feature-clean feature-primary explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                <div class="icons text-primary text-center mx-auto">
                  <i class="uil uil-ruler-combined d-block rounded h3 mb-0"></i>
                </div>

                <div class="card-body p-0 content">
                  <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Maintenance & Support</a></h5>
                  <p class="text-muted">Assurez la continuité de vos opérations avec notre service de maintenance proactive et notre support technique 24/7 pour toutes vos infrastructures IT critiques.</p>

                  <a href="javascript:void(0)" class="text-primary">En savoir plus <i
                      class="uil uil-angle-right-b align-middle"></i></a>
                </div>
              </div>
            </div>
            <!--end col-->
          </div>
        </div>
      </div>
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
        <div class="position-relative">
          <img src="assets/images/company/about2.png" class="img-fluid mx-auto" alt="">
          <div class="play-icon">
            <a (click)="openModal(contentmodal)" href="javascript:void(0);" class="play-btn video-play-icon border-0">
              <i class="mdi mdi-play text-primary rounded-circle shadow"></i>
            </a>
            <ng-template #contentmodal let-modal>
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <youtube-player [videoId]="'FEZvro_Tl9c'" height="450" width="780">
                </youtube-player>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
        <div class="section-title ms-lg-4">
          <h4 class="title mb-4">Nous sommes les experts <br> en transformation digitale</h4>
          <p class="text-muted">Collaborez avec notre ESN pour bénéficier de solutions complètes en design de produits IT, support technique, automatisation, ingénierie et conseil Cloud DevOps. Nous aidons nos clients à tirer parti de l'IA pour optimiser leurs activités. Notre approche centrée sur l'innovation et l'excellence technique fait de nous le partenaire idéal pour votre transformation numérique.</p>
          <a href="javascript:void(0)" class="btn btn-primary mt-3">Nous contacter <i class="mdi mdi-chevron-right"></i></a>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>

<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h4 class="title mb-4">Nos Compétences Technologiques</h4>
          <p class="text-muted para-desc mx-auto mb-0">Découvrez notre expertise en solutions IT innovantes : architectures Cloud, DevOps, intelligence artificielle et automatisation pour transformer votre entreprise.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <app-features></app-features>
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- Start -->
<section class="section bg-white pt-0">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="video-solution-cta position-relative" style="z-index: 1;">

          <div class="position-relative">
            <img src="assets/images/cta-bg.jpg" class="img-fluid rounded-md shadow-lg" alt="">
            <div class="play-icon">
              <a (click)="openWindowCustomClass(content)" href="javascript:void(0);" class="play-btn video-play-icon border-0">
                <i class="mdi mdi-play text-primary rounded-circle shadow-lg"></i>
              </a>
              <ng-template #content let-modal>
                <div class="modal-header">
                  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <youtube-player [videoId]="'FEZvro_Tl9c'" height="450" width="780">
                  </youtube-player>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="content mt-md-4 pt-md-2">
            <div class="row justify-content-center">
              <div class="col-lg-10 text-center">
                <div class="row align-items-center">
                  <div class="col-md-6 mt-4 pt-2">
                    <div class="section-title text-md-start">
                      <h6 class="text-white-50">Équipe</h6>
                      <h4 class="title text-white title-dark mb-0">Rencontrez notre <br> équipe d'experts</h4>
                    </div>
                  </div>

                  <div class="col-md-6 col-12 mt-4 pt-md-2">
                    <div class="section-title text-md-start">
                      <p class="text-white-50 para-desc">Collaborez avec notre ESN pour bénéficier de tout ce dont vous avez besoin pour générer de la visibilité, attirer du trafic et vous connecter.</p>
                      <a href="javascript:void(0)" class="text-white title-dark">Découvrir nos services <i-feather name="arrow-right"
                          class="fea icon-sm"></i-feather></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row -->
    <div class="feature-posts-placeholder bg-primary"></div>
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- End -->

<section class="section">
  <div class="container mt-100 mt-60">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h4 class="title mb-4">Ce que disent nos clients</h4>
          <p class="text-muted para-desc mx-auto mb-0">Découvrez les témoignages de nos clients satisfaits qui ont bénéficié de nos solutions IT innovantes en Cloud DevOps, intelligence artificielle et transformation digitale.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row justify-content-center">
      <div class="col-lg-12 mt-4">
        <app-testimonial [testimonialData]="testimonialData"></app-testimonial>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row align-items-center mb-4 pb-2">
      <div class="col-lg-6">
        <div class="section-title text-center text-lg-start">
          <h6 class="text-primary">Blog</h6>
          <h4 class="title mb-4 mb-lg-0">Découvrez nos dernières <br> actualités & articles</h4>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-6">
        <div class="section-title text-center text-lg-start">
          <p class="text-muted mb-0 mx-auto para-desc">Découvrez nos dernières actualités et insights sur les technologies IT, Cloud DevOps, intelligence artificielle et transformation digitale pour rester à la pointe de l'innovation.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <app-blog [blogData]="blogData"></app-blog>
  </div>
  <!--end container-->
</section>
<!--end section-->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
